/**
 * Predicate for React Query's `invalidateQueries({ predicate })`: matches queries whose
 * generated key leads with `{ url }` and that url is in `urls`. Mirrors the inline predicate the
 * task realtime subscribers use, shared here so the workflow subscribers don't re-implement it.
 */
export const createUrlQueryPredicate =
  (urls: string[]) =>
  (query: { queryKey: readonly unknown[] }): boolean => {
    const key = query.queryKey[0];
    if (typeof key !== "object" || key === null || !("url" in key)) return false;
    return urls.includes((key as { url: string }).url);
  };
